/** "More options" vertical-dots icon — filled, not stroked, so it doesn't use the Icon.tsx wrapper (which assumes fill="none"). */
export function MenuIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24">
      <circle cx="12" cy="6" r="1.3" fill="currentColor" />
      <circle cx="12" cy="12" r="1.3" fill="currentColor" />
      <circle cx="12" cy="18" r="1.3" fill="currentColor" />
    </svg>
  );
}
